
<template>
  <footer id="footer">
    <div class="slider" >

      <div ><button></button></div>
      <div class="centr"><button></button></div>
      <div ><button></button></div>

    </div>
  </footer>

</template>

<script>
// src="footer.js"

export default {
  components: {},
}


</script>

<style scoped>
button{
  height: 10px;
  width: 50px;
}
button:hover{
  background: darkred;
}

footer {
  position: relative;
  height: 50px; /* Або будь-яка висота, яка вам потрібна */
}

.slider {
  display: flex;
  justify-content: center;
  height: 55%;
}
.centr button{
  width: 150px;
  margin:0 15px 0 15px;
}


</style>
